<template>
  <div>
    <mdb-modal centered @close="cancel" elegant>
      <mdb-modal-header>
        <mdb-modal-title class="isi-heading-blue">{{ header }}</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <form v-on:submit.prevent v-on:keyup.enter="submit">

          <!-- display name -->
          <mdb-input
            class="m-0 mb-1 mt-3"
            label="Teststudio Name"
            type="text"
            v-model="testStudio.displayName"
            outline
          />


          <!-- contact section heading -->
          <p class="formular-section-heading">Contact</p>

          <!-- contact name -->
          <mdb-input
            class="m-0 mb-1 mt-3"
            label="Name"
            type="text"
            v-model="testStudio.contactName"
            outline
          />

          <!-- contact email -->
          <mdb-input
            class="m-0 mb-1 mt-3"
            label="Email"
            type="text"
            v-model="testStudio.contactEmail"
            outline
          />

          <div class="spacer"></div>

          <!-- location -->
          <div class="p-0 px-2 mb-4" style="border:1px solid #00000025; border-radius:0.2em;">
            <div style="position:relative; margin-top:-0.8em; ">
              <span style="margin: 0; padding:2px 4px; background: white; font-size:0.9em; font-weight: 300; color: #0000009a; display:inline-block; ">
                Location
              </span>
            </div>
            <div class="d-flex flex-row align-items-center justify-content-between" style="margin-top:-10px;">
              <p class="m-0">{{ locationOutputString }}</p>
              <put-location-modal :key="this.testStudio.id" :options="this.testStudio?.locationData ?? null" @submit="setLocationData"/>
            </div>
          </div>

          <!-- images -->
          <p class="formular-section-heading">Images</p>
          <div class="custom-file">
            <input type="file" @change="addImages" multiple class="custom-file-input" id="inputGroupFile01">
            <label class="custom-file-label" for="inputGroupFile01">Add images</label>
          </div>

          <!-- carousel -->
          <form v-if="this.testStudio.images.length > 0" v-on:submit.prevent v-on:keydown.enter.prevent v-on:keyup.enter.stop="updateImageCaption">
            <mdb-carousel :items="testStudio.images.length" multi indicators indicatorsColor="isi" navColor="isi">
              <template v-for="el, index in testStudio.images" #[index+1]>
                <div :key="'imageItem-' + index" style="position: relative;">
                  <div style="position:relative;">
                    <mdb-row style="position: relative;" md="4" class="d-md-inline-block px-3">
                      <img :src="el.relativePath" class="img-fluid rounded" style="border: 1px solid #00000020;" alt />
                    </mdb-row>
                    <div class="m-0 p-0" style="z-index:101; position: absolute; background-color: #a1a1a160; display: flex; justify-content: space-between; top: 0; width: 100%; height: auto;">
                      <a class="test-studio-icon-button" href="#!" role="button" @click="removeImageItem(index)">
                        <mdb-icon color="black" class="p-0 mx-2" icon="trash" ></mdb-icon>
                      </a>
                      <a class="test-studio-icon-button" href="#!" role="button"  @click="previewImageIndex = index">
                        <mdb-icon :far="previewImageIndex != index" class="p-0 mx-2" icon="star"></mdb-icon>
                      </a>
                    </div>
                    <div class="m-0 p-0" style="z-index:100; color:white; position: absolute; background-color: #00000090; display: flex; flex-direction: row; justify-content: space-between; align-items: center; top: 75%; width: 100%; height: auto; min-height: 2em; max-height: 3em;">
                      <p @click="() => { editImageCaption.index = index; editImageCaption.caption = el.caption; }" class="m-0 p-0 px-1 text-truncate" style="width: 100%; font-weight: 100; font-size: 0.9em;">
                        {{ el.caption }}
                      </p>
                      <div class="mx-1">
                        <a v-if="editImageCaption.index != index" @click="() => { editImageCaption.index = index; editImageCaption.caption = el.caption; }" class="m-0 p-0">
                          <mdb-icon size="sm" icon="pencil-alt"></mdb-icon>
                        </a>
                        <a v-else @click="updateImageCaption">
                          <mdb-icon size="sm" icon="check"></mdb-icon>
                        </a>
                      </div>
                    </div>
                  </div>
                  <mdb-input outline v-if="editImageCaption.index == index" style="z-index:100; background-color: white;" type="textarea" :rows="2" v-model="editImageCaption.caption" />
                </div>
              </template>
            </mdb-carousel>
          </form>

          <!-- test types section heading -->
          <p class="formular-section-heading">Test types</p>

          <!-- sensory lab -->
          <div class="custom-control custom-checkbox" type="button">
            <input type="checkbox" v-model="testStudio.isCertifiedSensoryLab" class="custom-control-input" id="testType-SensoryLabTest">
            <label class="custom-control-label cursor-pointer" for="testType-SensoryLabTest" style="cursor: pointer;">
              Sensory Lab Test
            </label>
          </div>

          <!-- quantitative -->
          <div class="custom-control custom-checkbox" type="button">
            <input type="checkbox" v-model="testStudio.isCertifiedCLTFacility" class="custom-control-input" id="testType-QuantitativeStudioTest">
            <label class="custom-control-label cursor-pointer" for="testType-QuantitativeStudioTest" style="cursor: pointer;">
              Quantitative Studio Test
            </label>
          </div>

          <!-- qualitative -->
          <div class="custom-control custom-checkbox" type="button">
            <input type="checkbox" v-model="testStudio.isCertifiedQualFacility" class="custom-control-input" id="testType-QualitativeStudioTest">
            <label class="custom-control-label cursor-pointer" for="testType-QualitativeStudioTest" style="cursor: pointer;">
              Qualitative Studio Test
            </label>
          </div>

          <!-- home-use -->
          <div class="custom-control custom-checkbox" type="button">
            <input type="checkbox" v-model="testStudio.isCertifiedHomeUseProvider" class="custom-control-input" id="testType-HomeUseTest">
            <label class="custom-control-label cursor-pointer" for="testType-HomeUseTest" style="cursor: pointer;">
              Home-Use Test
            </label>
          </div>

          <!-- facility -->
          <p class="formular-section-heading">Facility</p>
          <!-- has rate card -->
          <div class="custom-control custom-checkbox" type="button">
            <input type="checkbox" v-model="testStudio.hasRateCard" class="custom-control-input" id="testStudio-HasRateCard">
            <label class="custom-control-label cursor-pointer" for="testStudio-HasRateCard" style="cursor: pointer;">
              Has rate card
            </label>
          </div>

          <!-- has reference card -->
          <div class="custom-control custom-checkbox" type="button">
            <input type="checkbox" v-model="testStudio.hasReferenceCard" class="custom-control-input" id="testStudio-HasReference">
            <label class="custom-control-label cursor-pointer" for="testStudio-HasReference" style="cursor: pointer;">
              Has reference card
            </label>
          </div>


          <!-- full details pdf -->
          <p class="formular-section-heading">Full details file</p>
          <div class="custom-file">
            <input type="file" @change="(event) => { this.fullDetailsPdf = event.target.files[0]; this.testStudio.hasFullDetailsPDF = true; }" accept="application/pdf" class="custom-file-input" id="inputFullDetailsFile"
              aria-describedby="inputFullDetailsFile">
            <label class="custom-file-label" for="inputFullDetailsFile">Choose File (.pdf)</label>
            
            <!-- file name output -->
            <div v-if="fullDetailsFileName" class="d-flex flex-row align-content-center justify-content-between mt-2">
              <div class="d-flex flex-row align-items-center">
                <mdb-icon icon="file-pdf" size="lg" color="red" class="m-0 p-0 ml-2 my-2"></mdb-icon>
                <p class="m-0 p-0 px-2">{{ fullDetailsFileName }}</p>
              </div>
              <a href="#!" class="m-2 p-0" @click="() => { this.fullDetailsPdf = null; this.testStudio.hasFullDetailsPDF = false; }">
                <mdb-icon icon="trash" color="grey" class="m-0 p-0 mx-2"></mdb-icon>
              </a>
            </div>
          </div>

          <div class="spacer"></div>

          <!-- visibility -->
          <div class="my-1 mb-2">
            <select v-model="visibility" class="browser-default custom-select">
              <option v-for="item in ['public', 'only internal', 'hidden']" :key="item" :value="item">{{ item }}</option>
            </select>
            <!-- label -->
            <div class="select-label" :class="[(visibility) ? 'selected' : '']">
              <span class="p-0 px-1 m-0">Visibility</span>
            </div>
          </div>

          <div class="spacer"></div>

          <!-- features -->
          <!-- feature category 1 (Rooms & Facilities) -->
          <p class="formular-section-heading">Rooms & Facilities</p>
          <div>
            <div v-for="feature in features.filter(el => el.category === 3)" :key="feature.id">
              <mdb-row>
                <mdb-col col="7">
                  <div class="custom-control custom-checkbox" type="button">
                    <input type="checkbox" v-model="feature.selected" @change="updateFeatures(feature)" class="custom-control-input" :id="feature.id">
                    <label class="custom-control-label cursor-pointer" :for="feature.id" style="cursor: pointer;">
                      {{ feature.displayName }}
                    </label>
                  </div>
                </mdb-col>
                <mdb-col>
                  <select v-if="feature.selected" v-model="feature.availability" @change="updateFeatures(feature)" class="browser-default custom-select p-0 px-2" style="height: auto; max-height: 2em;">
                    <option v-for="availability in availabilities" :key="availability.value" :value="availability.value">{{ availability.name }}</option>
                  </select>
                </mdb-col>
              </mdb-row>
            </div>
          </div>

          <!-- feature category 2 (IT & Technology) -->
          <p class="formular-section-heading">IT & Technology</p>
          <div>
            <div v-for="feature in features.filter(el => el.category === 2)" :key="feature.id">
              <mdb-row>
                <mdb-col col="7">
                  <div class="custom-control custom-checkbox" type="button">
                    <input type="checkbox" v-model="feature.selected" @change="updateFeatures(feature)" class="custom-control-input" :id="feature.id">
                    <label class="custom-control-label cursor-pointer" :for="feature.id" style="cursor: pointer;">
                      {{ feature.displayName }}
                    </label>
                  </div>
                </mdb-col>
                <mdb-col>
                  <select v-if="feature.selected" v-model="feature.availability" @change="updateFeatures(feature)" class="browser-default custom-select p-0 px-2" style="height: auto; max-height: 2em;">
                    <option v-for="availability in availabilities" :key="availability.value" :value="availability.value">{{ availability.name }}</option>
                  </select>
                </mdb-col>
              </mdb-row>
            </div>
          </div>

          <!-- feature category 1 (Product Storage & Preparation) -->
          <p class="formular-section-heading">Product Storage & Preparation</p>
          <div>
            <div v-for="feature in features.filter(el => el.category === 1)" :key="feature.id">
              <mdb-row>
                <mdb-col col="7">
                  <div class="custom-control custom-checkbox" type="button">
                    <input type="checkbox" v-model="feature.selected" @change="updateFeatures(feature)" class="custom-control-input" :id="feature.id">
                    <label class="custom-control-label cursor-pointer" :for="feature.id" style="cursor: pointer;">
                      {{ feature.displayName }}
                    </label>
                  </div>
                </mdb-col>
                <mdb-col>
                  <select v-if="feature.selected" v-model="feature.availability" @change="updateFeatures(feature)" class="browser-default custom-select p-0 px-2" style="height: auto; max-height: 2em;">
                    <option v-for="availability in availabilities" :key="availability.value" :value="availability.value">{{ availability.name }}</option>
                  </select>
                </mdb-col>
              </mdb-row>
            </div>
          </div>
        </form>

        <div class="spacer"></div>

        <div v-if="testStudio.id != null" class="d-flex justify-content-end">
          <mdb-btn color="danger" icon="trash" class="btn-sm" @click="deleteTestStudio">Delete</mdb-btn>
        </div>

        <!-- validation message -->
         <div v-if="validationMessage">
          <div v-if="testStudio.id != null" class="spacer"></div>
          <p class="m-0 text-danger" style="font-size: 1em; font-weight: 100;">{{ validationMessage }}</p>
         </div>
        

      </mdb-modal-body>

      <mdb-modal-footer>
        <mdb-btn color="grey" class="btn-sm" @click="cancel">Cancel</mdb-btn>
        <mdb-btn color="isi" class="btn-sm" @click="submit">Submit</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>

<script>
import PutLocationModal from "./PutLocationModal.vue";

export default {
  components: {
    PutLocationModal,
  },
  props: {
    options: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      testStudio: {
        displayName: "",
        images: [],
        features: [],
      },
      fullDetailsPdf: null,
      previewImageIndex: null,
      editImageCaption: {
        index: null,
        caption: null,
      },
      availabilities: [
        {value: 1, name: 'rentable externally'},
        {value: 2, name: 'available'},
        {value: 3, name: 'rentable'},
        
      ],
      validationMessage: null,
    };
  },
  mounted() {
    this.setInitialState(this.options);
  },
  computed: {
    fullDetailsFileName() {
      if (this.fullDetailsPdf?.name) {
        return this.fullDetailsPdf.name;
      }

      console.log(this.testStudio);
      if (this.testStudio.hasFullDetailsPDF) {
        return `TestStudio${this.testStudio.id}.pdf`;
      }

      return null;
    },
    features: {
      get() {
        let features = Object.values(this.$store.state.features);
        let allFeatures = [];

        for (let item of features) {
          let feature = {
            id: item.id,
            category: item.category,
            displayName: item.displayName,
            availability: null,
            selected: false,
          };

          let availableFeature = this.testStudio?.features?.find(el => el.id == item.id && el.availability != 0);
          if (availableFeature != null) {
            feature.availability = availableFeature.availability;
            feature.selected = true;
          }

          allFeatures.push(feature);
        }
        return allFeatures;

      },
      set(value) {
        console.log('setter (computed)', value);
      },
    },
    isDev() {
      return process.env.NODE_ENV === 'development';
    },
    visibility: {
      get() {
        if(this.testStudio.hidden)
          return 'hidden';

        if(this.testStudio.internalOnly)
          return 'only internal';

        return 'public';
      },
      set(value) {
        if (value === 'hidden') {
          this.testStudio.hidden = true;
          this.testStudio.internalOnly = false;
        } else if (value === 'only internal') {
          this.testStudio.hidden = false;
          this.testStudio.internalOnly = true;
        } else {
          this.testStudio.hidden = false;
          this.testStudio.internalOnly = false;
        }
      },
    },
    initialState() {
      return this.options?.testStudio ?? {
        displayName: "",
      };
    },
    header() {
      return (!this.options) ? "Add Test Studio" : "Update Test Studio";
    },
    locationOutputString() {
      const locationData = this.testStudio?.locationData;
      const cityName = locationData?.cityData?.displayName;
      const countryName = locationData?.cityData?.countryData?.name;
      const continentName = locationData?.cityData?.countryData?.continentData?.name;

      if (cityName && countryName && continentName)
        return `${cityName}, ${countryName} (${continentName})`;

      return ' - ';
    },
  },
  methods: {
    pathIsDataUri(path) {
      return (path?.includes('data:image') && path?.includes('base64'));
    },
    getImageType(path) {
      // Check if the path contains a data URI
      if (this.pathIsDataUri(path)) {
        return path.split(';')[0].split(':')[1];
      }

      // Check if the path contains a file extension
      const imageUriSplit = path?.split('/') ?? [];
      if (imageUriSplit.length > 1) {
        const extension = imageUriSplit[imageUriSplit.length - 1];
        if (extension === 'png') return 'image/png';
        if (extension === 'jpeg' || extension === 'jpg') return 'image/jpeg';
      }

      return 'image/png';
    },
    resizeImage(dataUri, width, height, format = 'image/jpeg') {
      return new Promise((resolve, reject) => {
        const img = new Image();

        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');

          // Zeichne das Bild auf die Canvas mit der neuen Größe
          ctx.drawImage(img, 0, 0, width, height);

          // Konvertiere die Canvas in eine Data URI
          const resizedDataURI = canvas.toDataURL(format);
          resolve(resizedDataURI);
        };

        img.onerror = (error) => {
          reject(error);
        };

        img.src = dataUri;
      });
    },
    cropImageTo32(dataUri, format='image/png') {
      return new Promise((resolve, reject) => {
        const img = new Image();

        img.onload = () => {
          const originalWidth = img.width;
          const originalHeight = img.height;

          // Berechne die neue Breite und Höhe für das 3:2-Format
          const newHeight = originalHeight;
          const newWidth = (newHeight * 3) / 2;

          // Berechne die Startposition für das Zuschneiden
          const startX = (originalWidth - newWidth) / 2;
          const startY = 0;

          // Erstelle eine Canvas mit den neuen Abmessungen
          const canvas = document.createElement('canvas');
          canvas.width = newWidth;
          canvas.height = newHeight;
          const ctx = canvas.getContext('2d');

          // Zeichne das Bild auf die Canvas mit den neuen Abmessungen
          ctx.drawImage(img, startX, startY, newWidth, newHeight, 0, 0, newWidth, newHeight);

          // Konvertiere die Canvas in eine Data URI
          const croppedDataURI = canvas.toDataURL(format);
          resolve(croppedDataURI);
        };

        img.onerror = (error) => {
          reject(error);
        };

        img.src = dataUri;
      });
    },
    updateFeatures() {
      this.features.filter(el => !el.selected).forEach(el => el.availability = null);
      let features = this.features.filter(el => el.selected).map(el => {
        const availability = el.availability ?? 2;
        return {id: el.id, availability: availability};
      });

      this.testStudio.features = features;
    },
    setInitialState(options) {
      if (!options?.testStudio) {
        this.testStudio = {
          displayName: "",
          images: [],
          features: [],
          locationData: {
            cityData: null,
            geoCoordinate: {
              latitude: null,
              longitude: null,
            },
          },
        },
        this.previewImageIndex = null;
        this.editImageCaption = {
          index: null,
          caption: null,
        };

        return;
      }

      this.testStudio = JSON.parse(JSON.stringify(options?.testStudio));
    },
    updateImageCaption() {
      this.testStudio.images[this.editImageCaption.index].caption = this.editImageCaption.caption;
      this.editImageCaption.index = null;
      this.editImageCaption.caption = null;
    },
    removeImageItem(index) {
      this.previewImageIndex = null;
      this.testStudio.images.splice(index, 1);
    },
    addImages(event) {
      let imageItems = event.target.files;
      for (let i = 0; i < imageItems.length; i++) {

        let imageItem = {
          caption: imageItems[i]?.name,
          file: imageItems[i],
          relativePath: null,
        };

        const reader = new FileReader();
        reader.onload = (e) => {
          let imageUri = e.target.result;
          this.resizeImage(imageUri, 1920, 1080, imageItems[i].type)
          .then((resizedDataURI) => {
            imageItem.relativePath = resizedDataURI;
            this.testStudio.images.push(imageItem);
          });
        };
        reader.readAsDataURL(imageItems[i]);
      }
    },
    setLocationData(locationData) {
      console.log(locationData);
      this.testStudio.locationData = locationData;
    },
    cancel() {
      this.setInitialState(this.options);
      this.$store.commit("clearCurrentModal");
    },
    deleteTestStudio() {
      if(!window.confirm("Are you sure you want to delete this teststudio? \r\nThis action cannot be undone...")) {
        return;
      }

      this.$http({
        method: "delete",
        url: "/api/testStudio/delete",
        data: { id: this.testStudio.id },
      })
      .then(() => {
        this.$store.dispatch("getBackendData", this.$http);
        this.$store.commit("clearCurrentModal");
      })
      .catch((error) => {
        console.error(error);
      });
    },
    async submit() {
      
      let formData = new FormData();
      formData.append("fullDetailsPdf", this.fullDetailsPdf);

      this.validationMessage = null;

      if (this.previewImageIndex != null) {
        let previewImageObj = JSON.parse(JSON.stringify(this.testStudio.images[this.previewImageIndex]));
        const imageType = this.getImageType(previewImageObj.relativePath);

        const croppedImage = await this.cropImageTo32(previewImageObj.relativePath, imageType);
        const sizedPreviewImage = await this.resizeImage(croppedImage, 600, 400, imageType);
        this.testStudio.previewImagePath = sizedPreviewImage;
      }

      formData.append("testStudio", JSON.stringify(this.testStudio));

      this.$http({
        method: "post",
        url: "/api/testStudio/put",
        data: formData,
      })
      .then(() => {
        // console.log(response);
        this.$store.dispatch("getBackendData", this.$http)
        .then(() => {
          this.$router.go(0);
        });
      })
      .catch((error) => {
        if (error.response.status === 400) {
          this.validationMessage = error.response.data.message;
        }
        // console.error(error);
      });
    },
  },
};
</script>

<style scoped>
.spacer {
  width: 100% !important;
  height: 1em;
  margin: 1em 0;
}
.formular-section-heading {
  font-size:0.9em;
  font-weight: 100;
  margin: 0;
  margin-top: 2em;
  margin-bottom: 0.3em;
}
.test-studio-icon-button {
  color: white;
  opacity: 0.8;
}

.test-studio-icon-button:hover {
  color: white;
  opacity: 1;
}
</style>